<template>
   <div>
      <slot name="superheader" v-bind:parentToggledRow="parentToggledRow">
      </slot>

      <template>

         <ddoAlert :errors="errors"/>

         <v-row>
            <v-col :cols="options.width_tree">
               <v-treeview
                  dense
                  :return-object="options.return_object"
                  :selectable="options.selectable"
                  :activatable="options.activatable"
                  :items="rows"
                  item-key="_pk"
                  item-text="name"
                  :load-children="refresh_rows"
                  :active.sync="active"
                  :open.sync="open"
                  @update:active="select_active"
               >

                <template slot="prepend" slot-scope="props">
                    <slot name="prepend" :item="props.item" :active="props.active" v-scope="props">
                       <p>???</p>
                    </slot>
                </template>

                <template slot="label" slot-scope="props">
                    <slot name="label" :item="props.item" :active="props.active" v-scope="props">
                       <p>!!!</p>
                    </slot>
                </template>

                <template slot="append" slot-scope="props">
                    <slot name="append" :item="props.item" :active="props.active" v-scope="props">
                    </slot>
                </template>

               </v-treeview>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col :cols="options.width_form">
               <slot name="dialogform">
               </slot>
            </v-col>
         </v-row>  
      </template>

   </div>
</template>

<script>
import Vue from 'vue';
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';

export default {
   name: "ddoClientListTreeview",
   components: {
      ddoAlert,
   },
   props: {
      loading: Boolean,
      level: Object,
      row: Object,
      selection: null,
      childKey: {
         type: Number,
         default: function () {
            return null;
         }
      },
      callbacks: Object,
      columns: Array,
      nbCols: Number,
      nestedSlotNames: Array,
      options: Object
   },
   data: () => {
      return {
         rows: [ { _pk:0, name: "<root>", code: "", children: [] } ],
         errors: [],
         _openedChildRows: [],
         parentToggledRow: {},
         active: [],
         open: [],
         currentItem: null,
      }
   },

   created() {
   },

   async mounted() {
      if ( this.level.toggledRow ) {
         this.parentToggledRow = this.level.toggledRow;
      }
   },

   computed: {
   },

   methods: {
      /*
      * Retrieve the full record being toggled (open)
      * Need to be retrieve by sub-component
      */ 
      getToggledRow: function(key) {
         let _ret = false;
         let _len = this.rows.length;
         if ( this.level.options.uniqueKey && key>0 ) {
            for( var i=0; i<_len; i++) {
               if ( this.rows[i][this.level.options.uniqueKey]==key) { return this.rows[i]; }
            }
         }
         return false;
      },

      find_item_by_key(key, items=null) {
         if (!items) {
            items = this.rows;
         }
         return items.reduce( (acc, item) => {
            if (acc) {
               return acc;
            }
            if ( item._pk === key ) {
               return item;
            }
            if ( item.children ) {
               return this.find_item_by_key(key, item.children);
            }
            return acc;
         }, null )
      },

      set_one_row(row) {
      },

      async select_active(values) {
         // values could be either an array of 'key' or an array of 'item', depending of return-object property of the treeview
         if ( values[0] ) {
            this.currentItem = this.find_item_by_key( values[0]._pk, this.rows );
            var { errorinfos, api_response } = await this.refresh_row(this.currentItem,values[0]._pk);
            this.errors = [ errorinfos ];
         }
         if ( this.callbacks.prepare_update ) {
            await this.callbacks.prepare_update(this.currentItem);
         }
         this.$emit('selectActive',values,this.currentItem);
      },

      async refresh_rows_for_items(item) {
         if ( typeof this.callbacks.refresh_rows == 'function' ) {
            var { errorinfos, api_response } = await this.callbacks.refresh_rows(item.code);
         } else {
            this.$emit('loading',true);
            var { errorinfos, api_response } = await this.$api.getRows(this.$router,this.level.api_code);
            this.$emit('loading',false);
         }
         return { errorinfos, api_response }
      },

      async refresh_row(item,_pk) {
         //console.log('ddoClientListTreeview.refresh_row, _pk='+_pk);
         if ( typeof this.callbacks.refresh_row == 'function' ) {
            var { errorinfos, api_response } = await this.callbacks.refresh_row(_pk);
         } else {
            this.$emit('loading',true);
            var { errorinfos, api_response } = await this.$api.getRow(this.$router,this.level.api_code,_pk);
            this.$emit('loading',false);
         }
         if ( api_response.error==0 && api_response.row ) {
            item = this.set_one_row(api_response.row);
            //console.log('ddoClientListTreeview.refresh_row, END, item='+JSON.stringify(item));
         } else {
            this.$emit('errors',this.level.level,[errorinfos]);
         }
         return { errorinfos, api_response }
      },

      async refresh_rows(item) {
         if ( typeof this.callbacks.refresh_rows == 'function' ) {
            var { errorinfos, api_response } = await this.callbacks.refresh_rows(item);
         } else {
            this.$emit('loading',true);
            var { errorinfos, api_response } = await this.$api.getRows(this.$router,this.level.api_code);
            this.$emit('loading',false);
         }
         this.errors = [ errorinfos ];
         var items = [];
         if ( api_response.error==0 && api_response.rows ) {
               for( var i=0;i<api_response.rows.length;i++) {
                  items[i] = { _pk: api_response.rows[i]._pk, name: api_response.rows[i]._name, code: api_response.rows[i]._code }
                  if ( api_response.rows[i].ldt_is_ou==true ) {
                     items[i].children = [];
                  } 
               }
         }
         item.children = items;
      },

      is_child_open(key) {
         let _pos = this._openedChildRows.indexOf(key);
         return _pos>=0;
      },

      toggle_childrow(key) {
         if ( this.is_child_open(key) ) {
            this._openedChildRows.splice(this._openedChildRows.indexOf(key),1);
         } else {
            this._openedChildRows.push(key);
            this.toggledRow = this.getToggledRow(key);
            this.$emit('childKey',this.level.level+1,key,this.toggledRow);
         }
         this.$refs.myTable.toggleChildRow(key);
      },
   },

   provide: function() {
      return {
         refresh_rows: this.refresh_rows
      }
   }

}
</script>